import React, { useEffect, useState } from "react";
import { SquareTitle, MediaTemplateWithDialog } from "../../../components";
import { MEDIA_TYPE, PublicationType } from "../../../const";
import { useSettings } from "../../../context";
import { getReportsData, legislativeListLanguageMap } from "../../../utils";

const multilingual = {
  en: {
    title: "Legislative Council Papers",
  },
  cn: {
    title: "立法會文件",
  },
};

export const LegislativeCouncil: React.FC = () => {
  const { isPC, getPageText, language } = useSettings();
  const page_text = getPageText(multilingual);

  const [legislativeCouncilList, setLegislativeCouncilList] = useState<
    PublicationType[]
  >([]);
  const { title } = page_text;

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(legislativeListLanguageMap[language]);
      const data = await response.json();
      setLegislativeCouncilList(getReportsData(data));
    };
    fetchData();
  }, [language]);

  return (
    <div>
      <SquareTitle title={title as string} />
      <div
        className={`w-full pt-[24px] ${
          isPC
            ? "grid grid-cols-3 gap-x-[24px] gap-y-[36px]"
            : "flex flex-wrap gap-x-[24px]"
        }`}
      >
        {legislativeCouncilList.map((item, index) => {
          const { title, date = "", mediaType, link } = item;

          const isPDF = mediaType === MEDIA_TYPE.PDF;
          const maskIcon = isPDF ? "PDF.png" : "VIDEO.png";
          return (
            <div
              key={index}
              className={`${
                isPC ? "w-full h-[282px]" : "w-[252px] h-[282px]"
              } flex flex-col gap-[14px]`}
            >
              <MediaTemplateWithDialog
                title={title.length > 56 ? title.slice(0, 56) + "..." : title}
                maskIcon={maskIcon}
                date={date}
                mediaLink={link}
                mediaType={mediaType}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
